import { ExpenseNotCoveredStep } from "#/components/carrot-card-cost-share/steps/views/ExpenseNotCoveredStep"
import { RelatedToStorageFeesStep } from "#/components/carrot-card-cost-share/steps/views/RelatedToStorageFeesStep"
import { GeneralSteps, GestationalSteps, SectionName } from "#/components/carrot-card-cost-share/workflows/step-library"
import { RelatedToMedicationExpensesGestationalStep } from "#/components/carrot-card-cost-share/steps/views/RelatedToMedicationExpensesGestationalStep"
import { WhoWillReceiveCareGCStep } from "#/components/carrot-card-cost-share/steps/views/WhoWillReceiveCareGestationalStep"
import { RelatedToStorageFeesValues } from "#/components/carrot-card-cost-share/steps/shared/stepOptionValues"

export enum Workflows {
  GESTATIONAL = "Gestational"
}

export const gestationalSteps = [
  { name: GestationalSteps.RELATED_TO_STORAGE_FEES_GC, component: RelatedToStorageFeesStep },
  { name: GestationalSteps.WHO_WILL_RECEIVE_CARE_GC, component: WhoWillReceiveCareGCStep },
  { name: GestationalSteps.RELATED_TO_MEDICATION_EXPENSES_GC, component: RelatedToMedicationExpensesGestationalStep },
  { name: GestationalSteps.EXPENSE_NOT_COVERED_GC, component: ExpenseNotCoveredStep }
]

//prettier-ignore
const gestationalFlow: GestationalFlowTransition[] = [
  { at: GestationalSteps.RELATED_TO_STORAGE_FEES_GC,        given: RelatedToStorageFeesValues.OTHER,                    goto: GestationalSteps.WHO_WILL_RECEIVE_CARE_GC },
  { at: GestationalSteps.RELATED_TO_STORAGE_FEES_GC,        given: RelatedToStorageFeesValues.FIRST_YEAR_STORAGE,       goto: GestationalSteps.WHO_WILL_RECEIVE_CARE_GC },
  { at: GestationalSteps.RELATED_TO_STORAGE_FEES_GC,        given: RelatedToStorageFeesValues.POST_FIRST_YEAR_STORAGE,  goto: GestationalSteps.WHO_WILL_RECEIVE_CARE_GC },
  { at: GestationalSteps.WHO_WILL_RECEIVE_CARE_GC,          given: "ELIGIBLE",                                          goto: GestationalSteps.RELATED_TO_MEDICATION_EXPENSES_GC },
  { at: GestationalSteps.WHO_WILL_RECEIVE_CARE_GC,          given: "INELIGIBLE",                                        goto: GestationalSteps.EXPENSE_NOT_COVERED_GC },
  { at: GestationalSteps.RELATED_TO_MEDICATION_EXPENSES_GC, given: "NOT_COVERED",                                       goto: GestationalSteps.EXPENSE_NOT_COVERED_GC },
  { at: GestationalSteps.RELATED_TO_MEDICATION_EXPENSES_GC, given: "",                                                  goto: GeneralSteps.TOTAL_COST,      sectionName: SectionName.GENERAL },
  { at: GestationalSteps.EXPENSE_NOT_COVERED_GC,            given: "",                                                  end: true }
]

type GestationalFlowTransition =
  | { at: GestationalSteps; given: string; goto: GestationalSteps; sectionName?: undefined }
  | { at: GestationalSteps; given: string; goto: GeneralSteps; sectionName: string }
  | { at: GestationalSteps; given: string; end: true }

export const gestationalWorkflows = [{ name: Workflows.GESTATIONAL, workflow: gestationalFlow }]
